import { ToggleSwitchDesignTokens } from '@primeuix/themes/aura/toggleswitch';

export const toggleSwitchTokens: ToggleSwitchDesignTokens = {
  root: {
    width: '2rem',
    height: '1.25rem',
    borderRadius: '3rem',
    gap: '0.25rem',
    shadow: '{form.field.shadow}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    transitionDuration: '{form.field.transition.duration}',
    slideDuration: '0.2s',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
  },
  handle: {
    borderRadius: '0.375rem',
    size: '0.75rem',
  },
  colorScheme: {
    light: {
      root: {
        background: '{color.main.tertiary}',
        hoverBackground: '{color.main.secondary}',
        checkedBackground: '{primary.color}',
        checkedHoverBackground: '{indigo.600}',
        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        checkedBorderColor: 'transparent',
        checkedHoverBorderColor: 'transparent',
        disabledBackground: '{form.field.disabled.background}',
      },
      handle: {
        background: '{surface.0}',
        hoverBackground: '{surface.0}',
        color: '{text.muted.color}',
        hoverColor: '{text.color}',
        checkedBackground: '{surface.0}',
        checkedHoverBackground: '{surface.0}',
        checkedColor: '{primary.color}',
        checkedHoverColor: '{primary.hover.color}',
        disabledBackground: 'rgba(46, 16, 101, 0.1)',
      },
    },
    dark: {
      root: {
        background: 'rgba(255, 255, 255, 0.64)',
        hoverBackground: 'rgba(255, 255, 255, 0.40)',
        checkedBackground: '{indigo.300}',
        checkedHoverBackground: '{primary.color}',
        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        checkedBorderColor: 'transparent',
        checkedHoverBorderColor: 'transparent',
        disabledBackground: '{surface.600}',
      },
      handle: {
        background: '{indigo.950}',
        hoverBackground: '{indigo.950}',
        color: '{surface.900}',
        hoverColor: '{surface.800}',
        checkedBackground: '{surface.900}',
        checkedHoverBackground: '{surface.900}',
        checkedColor: '{primary.color}',
        checkedHoverColor: '{primary.hover.color}',
        disabledBackground: '{surface.900}',
      },
    },
  },
};
